import type { Shape } from '@hcie/shared';
import { g } from '@hcie/core';

function clamp(n: number) {
    return Number.isFinite(n) ? n : 0;
}

function getStyleFromGlobals(extra?: Record<string, any>) {
    return {
        width: (g as any).pen_width ?? 2,
        color: (g as any).pen_color ?? '#000',
        opacity: (g as any).pen_opacity ?? 1,
        cap: 'round',
        hardness: (g as any).brush_hardness ?? 1,
        fill: !!(g as any).shape_fill,
        fillColor: (g as any).pen_secondary_color,
        cornerRadius: (g as any).round_rect_corner_radius ?? 10,
        ...(extra || {})
    };
}

export function toolToShape(toolId: string, x1: number, y1: number, x2: number, y2: number): Shape | null {
    const sx1 = clamp(x1);
    const sy1 = clamp(y1);
    const sx2 = clamp(x2);
    const sy2 = clamp(y2);

    // Tool ids in this project are button ids like 'btn-rect', etc.
    if (toolId === 'btn-line' || toolId.includes('Line')) {
        return { type: 'line', x1: sx1, y1: sy1, x2: sx2, y2: sy2, style: getStyleFromGlobals({ fill: false }) } as any;
    }
    if (toolId === 'btn-rect' || toolId.includes('Rectangle')) {
        return { type: 'rect', x1: sx1, y1: sy1, x2: sx2, y2: sy2, style: getStyleFromGlobals() } as any;
    }
    if (toolId === 'btn-rounded-rect' || toolId.includes('Rounded_Rectangle')) {
        return { type: 'roundrect', x1: sx1, y1: sy1, x2: sx2, y2: sy2, style: getStyleFromGlobals() } as any;
    }
    if (toolId === 'btn-ellipse' || toolId.includes('Ellipse')) {
        return { type: 'ellipse', x1: sx1, y1: sy1, x2: sx2, y2: sy2, style: getStyleFromGlobals() } as any;
    }
    if (toolId === 'btn-circle' || toolId.includes('Circle')) {
        // In shared renderer, circle uses (x1,y1) as center and (x2,y2) as a point on radius.
        return { type: 'circle', x1: sx1, y1: sy1, x2: sx2, y2: sy2, style: getStyleFromGlobals() } as any;
    }

    return null;
}

